var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selector day-selector",attrs:{"clearable":false,"searchable":_vm.allowSearch,"options":_vm.monthDays,"value":_vm.selectedDay},on:{"input":_vm.changeDay,"search:focus":_vm.fixHighlight}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(" Insira um dia válido ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }